import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as ReimbursementsService from '../../../services/api/reimbursement';
import * as NotificationService from '../../../services/api/notification';
import * as RequestInformation from '../../../services/api/info_request';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';

class FetchReimbursementsList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REIMBURSEMENT_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REIMBURSEMENT_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REIMBURSEMENT_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: ReimbursementsService.FetchReimbursementsListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ReimbursementsService.fetchReimbursementsList(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcReminderList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchUnreadNotificationCount implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Failed,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchUnreadNotificationCount();
        dispatch(this.onSuccess(response.data.total));
      } catch (error: any) {
        // console.log('FetchUnreadNotificationCount Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ClearUnreadNotificationCount implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

class UpdateReimburseInfo implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UPDATE_REIMBURSE_INFO,
      status: StateStatus.Pending,
      data: {},
    };
  }

  onSuccess(): IAction {
    return {
      type: Types.SET_UPDATE_REIMBURSE_INFO,
      status: StateStatus.Success,
      data: {},
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UPDATE_REIMBURSE_INFO,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: ReimbursementsService.UpdateReimburseInfoInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await ReimbursementsService.UpdateReimburseInfo(payload);
        const state = getState(ReducerKeys.REIMBURSEMENTS_LIST_REDUCER)
          .ReimbursementsList.data;
        const paging = state.paging;
        const sorting = state.sorting;
        dispatch(
          new FetchReimbursementsList().action({
            sortField: sorting.sortField,
            page: paging.page,
            pageSize: paging.pageSize,
            order: sorting.order,
            ...payload.searchParams,
          })
        );
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_UPDATE_REIMBURSE_INFO,
          })
        );
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('UpdateReimburseInfo Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchReimbursementsListAction: (
    payload: ReimbursementsService.FetchReimbursementsListInput
  ) => new FetchReimbursementsList().action(payload),
  fetchUnreadNotificationCountAction: () =>
    new FetchUnreadNotificationCount().action(),
  clearUnreadNotificationCountAction: () =>
    new ClearUnreadNotificationCount().action(),
  updateReimburseInfoAction: (
    payload: ReimbursementsService.UpdateReimburseInfoInput
  ) => new UpdateReimburseInfo().action(payload),
};
